// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  assignmentId: __t.u64().primaryKey().name("assignment_id"),
  groupRunId: __t.u64().name("group_run_id"),
  email: __t.string(),
  displayName: __t.string().name("display_name"),
  connected: __t.bool(),
  pendingChecks: __t.u32().name("pending_checks"),
  currentBeat: __t.u32().name("current_beat"),
  totalBeats: __t.u32().name("total_beats"),
  stdbIdentity: __t.string().name("stdb_identity"),
  completed: __t.bool(),
  passed: __t.option(__t.bool()),
  scorePct: __t.option(__t.u32()).name("score_pct"),
  arrived: __t.bool(),
  ready: __t.bool(),
});
